/**
 * @fileoverview Agent definition for the genre-detector-v2 primitive.
 *
 * This agent detects genres from a text sample by analyzing its style,
 * content, and conventions against a list of available genre templates.
 *
 * @category import.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'genre-detector-v2',
  kind: 'primitive',
  name: 'Genre Detector',
  description: 'Analyzes a text sample to detect matching genres from a list of available genre templates.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2025-01',
    lastUpdated: '2025-01',
    taxonomyPath: 'import.story.analysis',
    usedBy: [],
    usedInComposites: ['extract-styleguide-v2'],
    relatedAgents: ['extract-story-dna-v2', 'style-analyzer-v2'],
  },
};
